/**
 * ユーティリティ関数とconfig値
 */
class AnyStore {

  constructor() {

  }

  getWindowWidth() {
    return (Useragnt.pc && Useragnt.windows) ? document.body.clientWidth : window.innerWidth;
  }

  getClientHeight() {
    return document.documentElement.clientHeight || document.body.clientHeight;
  }

  getScrollTop() {
    return window.scrollY || document.documentElement.scrollTop || document.body.scrollTop;
  }

  getScrollHeight() {
    return document.documentElement.scrollHeight || document.body.scrollHeight;
  }

  /**
   * elementのtop位置を返す
   */
  getOffset(selector) {
    let rect = null;
    if (typeof selector === 'string') {
      rect = document.querySelector(selector).getBoundingClientRect();
    } else if (selector !== undefined) {
      rect = selector.getBoundingClientRect();
    }

    if (rect) {
      return {
        orig: rect,
        offset: {
          top: rect.top + this.getScrollTop(),
          left: rect.left
        }
      }
    }

    return null;
  }

  /**
   * MatchMedia（メディアクエリ）による判別
   */
  getMatchMedia() {
    return window.matchMedia('(max-width: 900px)').matches;
  }

  /**
   * 現在のデバイスを判別（ブラウザ幅）
   */
  setDevice() {
    return this.getMatchMedia() ? 'sp' : 'pc';
  }

  /**
   * クエリストリングを配列にする
   */
  parseQuery() {
    let vars = [], max = 0, hash = "", array = "";
    const url = window.location.search;

    hash  = url.slice(1).split('&');
    max = hash.length;
    for (let i = 0; i < max; i++) {
      array = hash[i].split('=');
      vars.push(array[0]);
      vars[array[0]] = array[1];
    }

    return vars;
  }

  /**
   * クエリストリング取得
   */
  getURLParams() {
    const parsed = this.parseQuery();
    return parsed;
  }

  /**
   * aタグを探す
   */
  getHref(el) {
    if (!el)
    {
      return undefined;
    }

    if (el.getAttribute && typeof el.getAttribute('xlink:href') === 'string')
    {
      return el.getAttribute('xlink:href');
    }

    if (typeof el.href === 'string')
    {
      return el.href;
    }

    return undefined;
  }

  /**
   * 文字列をバイト数でカウントする
   */
  byteCount(str) {
    let r = 0;
    for (let i = 0; i < str.length; i++) {
      const c = str.charAt(i);

      if (this.isZenkaku(c)) {
        r += 2;
      } else {
        r += 1.3;
      }
    }

    return r;
  }

  isZenkaku(str) {
    return (str.match(/^[\u0020-\u007e]+$/)) ? false : true;
  }

  byteAjust(str, count) {
    let r = 0, line = '';
    for (let i = 0; i < str.length; i++) {
      const c = str.charAt(i);

      if (this.isZenkaku(c)) {
        r += 2;
      } else {
        r += 1.3;
      }

      if (r > count) break;

      line += str.charAt(i);

      //console.log(r, count, line);
    }

    return line + '…';
  }

  getCurrentState() {
    if (location.pathname === '/' || location.pathname === '/en/') {
      return 'home';
    } else {
      return null;
    }
  }

  // ----------------------------------------
  // minからmaxまでランダム
  // ----------------------------------------
  random(min, max) {
    return Math.random() * (max - min) + min;
  }

  // ----------------------------------------
  // minからmaxまでランダム int
  // ----------------------------------------
  randomInt(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }

  // ----------------------------------------
  // -valからvalまでランダム
  // ----------------------------------------
  range(val) {
    return this.random(-val, val);
  }

  // ----------------------------------------
  // 配列の中ランダム
  // ----------------------------------------
  randomArr(arr) {
    return arr[this.randomInt(0, arr.length - 1)]
  }

  // 1 / rangeの確率でtrueを取得
  // -----------------------------------
  // @range : 2以上の分母(int)
  // return : true or false(boolean)
  // -----------------------------------
  hit(_range) {
    return (this.randomInt(0, _range - 1) == 0)
  }

  // ----------------------------------------
  // minからmaxまでランダム 半分の確率で-をつける
  // ----------------------------------------
  random2(min, max) {
    let val = Math.random() * (max - min) + min;
    if(Math.random() > 0.5) {
      val *= -1;
    }
    return val;
  }

  getOffsetTop(el) {
    let targetY = el.offsetTop;
    let parent = el.offsetParent;
    while (parent && parent != document.body) {
      targetY += parent.offsetTop;
      parent = parent.offsetParent;
    }
    return {top: targetY, parent: parent};
  }

  shiftBox(el) {
    const num = this.randomInt(0, 6);
    if (num > 0) {
      el.className = el.className + ` u-shift-lt${num}`;
    }
  }

  /**
   * イージング
   */
  /*easeOut(p) {
    return p * (2 - p);
  }*/

  outQuad(t){
    return -t*(t-2);
  }

  quad(t){
    return t*t;
  }

  cubic(t){
    return t*t*t;
  }

  quart(t){
    return t*t*t*t;
  }

  quint(t){
    return t*t*t*t*t;
  }

  expo(t) {
    return Math.pow(2,-(1- t) * 10);
  }

  QuadOut(t) {
    return 1 - this.quad(1 - t);
  }

  CubicOut(t) {
    return 1 - this.cubic(1 - t);
  }

  QuartOut(t) {
    return 1 - this.quart(1 - t);
  }

  QuintOut(t) {
    return 1 - this.quint(1 - t);
  }

  ExpoOut(t) {
    return 1 - this.expo(1 - t);
  }
}

const AnyStoreInstance = new AnyStore();

// 既存のプロパティ属性と値の変更、および新しいプロパティの追加を防止
Object.freeze(AnyStoreInstance);

export default AnyStoreInstance;